/**
 * 图片图层 AI：开启高级 AI 时在图片层展示弹层菜单（扩图、改图、生图等），含是否带花字能力透传。
 */
import React from 'react';
import type { IShortcutMenuItemRenderArgs } from '@/plugins/shortcut-menu/type';
import { LayerType, type IImageLayerProps } from '@/version-types';
import ImageLayerAiPopover from './popover';

export { Env, setImageLayerAiMenuConfig } from './config';

export const imageLayerAiShortcutItem = ({ layer, advancedAiEnabled }: IShortcutMenuItemRenderArgs) => {
    const isImageLayer = layer.layerType === LayerType.IMAGE_LAYER;
    const hasAiText =
        (layer.layerType === LayerType.IMAGE_LAYER && (layer.data as IImageLayerProps).aiTextExtension) ||
        layer.layerType === LayerType.TEXT_LAYER;

    if (!advancedAiEnabled || !isImageLayer) return null;

    return <ImageLayerAiPopover hasAiText={!!hasAiText} />;
};
